<template>
  <div class="container">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="测试结果"  v-if="form.title != ''">
        <el-input
          v-model="form.title"
          placeholder="请填写测试结果 最多50个字"
          style="width: 750px"
          maxlength="50"
         
        ></el-input>
      </el-form-item>
      <el-form-item label="测试说明">
        <tinymce v-model="form.detail" style="width: 66%"></tinymce>
      </el-form-item>
      <div class="set">推荐设置 <span>(选填，支持课程，个案和电商)</span></div>
      <el-form-item

        v-for="(option, index) in form.recommend"
        :key="index"
      >
        <label class="optionlist">
          <el-input
            type="number"
            v-model="option.id"
            :placeholder="'输入'"
          ></el-input>
          <el-input
            type="number"
            v-model="option.coupon_id"
            placeholder="输入"
            v-if="option.type == 1"
          ></el-input>
          <el-radio-group v-model="option.type" class="group">
            <el-radio v-model="option.type" :label="1">课程</el-radio>
            <el-radio  v-model="option.type" :label="2" >商品</el-radio>
            <el-radio  v-model="option.type" :label="3" >个案</el-radio>
          </el-radio-group>
          <i class="el-icon-delete" @click="removeOption(index)"></i>
        </label>
        <div class="option_title" v-if="option.title">{{ option.title }}</div>
        <div class="option_title" v-if="option.coupon">{{ option.coupon }}</div>
      </el-form-item>
      <el-form-item>
        <el-button @click="addOption">新增</el-button>
      </el-form-item>
      <el-form-item>
        <div class="submitbtn">
        <el-button type="primary" @click="onSubmit(ids)" v-if="isShow">保存</el-button>
        <el-button type="primary" @click="onUpdata(ids)" v-else
            >修改</el-button
          >
          <el-button class="goTopicHandel" @click="goTopicHandel">回到题目设置</el-button>
          <el-button class="goListHandel" @click="goListHandel">前往设置海报</el-button>
      </div>
      </el-form-item>
    </el-form>
  </div>
</template>
    
    <script>
import tinymce from "@/components/tinymce.vue";
import { createResult ,updateResult} from '@/api/coupon';
export default {
  data() {
    return {
      form: {
        test_id:'',
        title: "", // 测试结果
        detail: "", // 结果描述
        type:1,
        recommend: [],
      },
      ossAction: "",
      isShow:true,
      result_id:0,
      testid:'',
      testtype:''
    };
  },
  created(){
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(hash.indexOf("?") + 1));
    this.form.test_id = params.get("id");
    this.testid = params.get("id");
    this.testtype = params.get("type");
  },
  props:["tablelist","editableTabs","ids","resultList"],
  components: {
    tinymce,
  },
  mounted(){
   
      if(this.resultList){
      if (Object.keys(this.resultList).length !== 0) {
      this.form = Object.assign({}, this.resultList);
      this.isShow = false
      this.result_id = this.form.id
    }
    }
    console.log(this.tablelist,'tablelist',this.editableTabs,this.ids,this.resultList);
  },
  methods: {
    goTopicHandel(){ // 回到题目设置
      this.$router.push(`/appraisal/topic?id=${this.testid}&type=${this.testtype}`)
    },
    goListHandel(){ // 前往设置海报
      this.$router.push(`/appraisal/list`)
    },
    radioHandel(value){
      console.log(value);
      value == 1?this.isShow =true:this.isShow =false
    },
    onSubmit(id) {
      
      this.form.title  = this.tablelist[id].name
      console.log(this.tablelist[id].name,id,this.form,typeof(this.form.recommend));
      createResult(this.form).then((res)=>{
        console.log(res);
        if(res.code == 1){
          this.result_id = res.data.result_id;
          this.$message({
            message: `恭喜你，结果${id+1}保存成功`,
            type: "success",
          });
          this.isShow = false
        }
      })
    },
    onUpdata(id) {
      console.log(this.result_id);
      this.form.title  = this.tablelist[id].name
      this.form.result_id = this.result_id
      console.log(this.form);
      updateResult(this.form).then((res) => {
        if (res.code == 1) {
         
          this.$message({
            message: `恭喜你，结果${id+1}修改成功`,
            type: "success",
          });
        }
      });
    },
    addOption() {
      // 添加
      if (this.form.recommend.length >= 3) {
        this.$message.error("最多添加三个");
        return;
      } else {
        this.form.recommend.push({'id':'','coupon_id':'0','type': 1 });
      }
      console.log("this.form.recommend.length", this.form.recommend.length);
    },
    removeOption(index) {
      // 删除
        this.form.recommend.splice(index, 1);
    },

  },
};
</script>
    
    <style>
.optionlist {
  display: flex;
  align-items: center;
}
.optionlist .el-input {
  width: 100px;
}
.el-icon-delete {
  cursor: pointer;
  margin-left: 10px;
  color: red;
}
.panduan .el-form-item__content {
  display: flex;
}
.panduan .el-form-item__content .el-input {
  width: 100px;
  margin: 0 10px;
}
.group {
  margin-left: 50px;
}
.set {
  font-size: 16px;
  margin-bottom: 20px;
}
.set span {
  color: #bbb;
}
</style>